import React from "react";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import BSInput from "../../../common/js/components/BSInput";

class OfficeForm extends React.Component {
    handleAttributeUpdate = (event) => {
        this.props.onChange(event.target.id, event.target.value);
    };

    render() {
        const { data, errors, disableInputs, context } = this.props;

        const formStyles = {
            row: {
                display: 'flex',
                flexWrap: 'wrap',
                margin: '0 -16px',
                alignItems: 'center',
                marginBottom: '16px'
            },
            rowStart: {
                display: 'flex',
                flexWrap: 'wrap',
                margin: '0 -16px',
                alignItems: 'flex-start',
                marginBottom: '16px'
            },
            column: {
                flex: '0 0 50%',
                padding: '0 16px',
                boxSizing: 'border-box'
            }
        };

        return (
            <div>
                <div style={formStyles.row}>
                    {context === "property" && (
                        <div style={formStyles.column}>
                            <BSInput
                                id="suite"
                                label="OFFICE SUITE NUMBER"
                                placeholder="Enter number"
                                error={errors.suite}
                                value={data.suite}
                                onChange={this.handleAttributeUpdate}
                                disabled={disableInputs}
                            />
                        </div>
                    )}
                    <div style={formStyles.column}>
                        <FormGroup>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={data.divisibleFlg ? true : false}
                                        onChange={(e, checked) => this.props.onChange(e.target.value, checked)}
                                        value="divisibleFlg"
                                        disabled={disableInputs === true}
                                        color="primary"
                                    />
                                }
                                label="Office Space Divisible"
                                style={{ marginBottom: "10px" }}
                            />
                        </FormGroup>
                    </div>
                </div>
                <div style={formStyles.rowStart}>
                    <div style={formStyles.column}>
                        <BSInput
                            id="officeSf"
                            label="OFFICE SF AVAILABLE"
                            placeholder="Enter SF"
                            errorText="ex. 98101"
                            error={errors.officeSf}
                            value={data.officeSf}
                            onChange={this.handleAttributeUpdate}
                            disabled={disableInputs}
                        />
                    </div>
                    <div style={formStyles.column}>
                        <BSInput
                            id="largestContigSf"
                            label="OFFICE CONTIGUOUS SF AVAILABLE"
                            placeholder="Enter SF"
                            error={errors.largestContigSf}
                            value={data.largestContigSf}
                            onChange={this.handleAttributeUpdate}
                            disabled={disableInputs}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

export default OfficeForm;